import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SelectLanguages from "@/components/shared/inputs/SelectLanguages";
import SelectInput from "@/components/shared/inputs/SelectInput";
import useQueryParams from "@/hooks/useQueryParams";
import { useTranslation } from "react-i18next";
import * as Icons from "@/assets/features/interview";
import PropTypes from "prop-types";

const InterviewLayout = ({ children }) => {
  const { i18n } = useTranslation();
  const isLTR = i18n.language||"en";

  const location = useLocation();
  const navigate = useNavigate();
  const { setParam, getParam } = useQueryParams();


  const isPersonalInterviewPage = location.pathname.startsWith(
    "/interview/personal"
  );


  
  const selectOptions = [
    { value: "video", label: "Video" },
    { value: "text", label: "Text" },
    { value: "form", label: "Form" },
    { value: "personal", label: "Personal" },
  ];
  const interviewType = getParam("type") ?? "video";

  const handleSelectChange = (val) => {
    if (val === "form") {
      navigate("before-you-begin?type=form");
      return;
    }
    if (val === "personal") {
      navigate("personal");
      return;
    }
    if (val === "text") {
      navigate("before-you-begin?type=text");
      return;
    }
    if (val === "video") {
      navigate("/interview?type=video");
      return;
    }
    setParam("type", val);
  };

  return (
    <main
      className={`bg-primary-foreground ${
        isPersonalInterviewPage
          ? "h-dvh flex flex-col py-2 px-3 sm:py-2 sm:px-7"
          : "min-h-screen sm:py-3 sm:px-7"
      }`}
    >
      <nav className="justify-between items-center mb-2 shrink-0 flex mx-auto w-full">
        <img
          src={Icons.FullLogo}
          width="200"
          height="200"
          className="h-[52px] w-auto max-w-[14rem]"
          alt="logo"
        />
        <div className="flex gap-3 items-center">
          <SelectLanguages />
        </div>
      </nav>
      <div
        className={`${
          isPersonalInterviewPage
            ? "flex-1 min-h-0 overflow-y-auto scroll-y-overlay lg:overflow-hidden"
            : ""
        }`}
      >
        {children}
      </div>
    </main>
  );
};


export default InterviewLayout;

InterviewLayout.propTypes = {
  children: PropTypes.node.isRequired,
};